import { Icon } from 'veui'
import { IconFileError } from 'dls-icons-vue'

Icon.register('file-error', IconFileError)
